.wrapper {
    display: inline-block;
    line-height: 0;
    border-radius: var(--tempest-radius-md);
    overflow: hidden;
}

.svg {
    display: block;
    width: 100%;
    height: 100%;
}
